import { getUnits, setPage } from '../../../actions/viewerActions'
import { classes, PaginatorStyle } from './style'
import { useDispatch, useSelector } from 'react-redux'

const UsePaginator = () => {
  const dispatch = useDispatch()

  const page = useSelector(state => state.viewer.page)
  const totalPages = useSelector(state => state.viewer.totalPages)
  const max = useSelector(state => state.viewer.max)
  const filters = useSelector(state => state.viewer.filters)

  const handleChange = (event, value) => {
    dispatch(setPage(value))
    dispatch(getUnits({ ...filters, max, page: value }))
  }
  return (
        <PaginatorStyle
            className={classes.root}
            color="primary"
            count={totalPages}
            page={page}
            onChange={handleChange}
        />
  )
}

export default UsePaginator
